export default "__VITE_ASSET__VCug$p39__"